import React, { useState } from 'react';
import { message, Spin } from 'antd';
import moment from 'moment';
import { ClockCircleOutlined, CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import './TimeslotSelector.less';

const TimeslotSelector = ({ selectedTimeslot: initialSelected, onContinue, timeslots = [], loading = false }) => {
	// const [selectedTimeslot, setSelectedTimeslot] = useState(initialSelected);
	const [selectedTimeslot, setSelectedTimeslot] = useState(null);

	const handleTimeSlotClick = (timeslot) => {
		const isClosed = timeslot.isClosed || (timeslot.last_order_time ? dayjs().isAfter(dayjs(timeslot.last_order_time)) : false);
		if (timeslot.isFull || isClosed) {
			return;
		}
		setSelectedTimeslot(timeslot._id);
	};

	const handleContinue = () => {
		if (!selectedTimeslot) {
			message.warning('Please select a timeslot');
			return;
		}
		const selected = timeslots.find(t => t._id === selectedTimeslot);
		onContinue(selected);
	};

	if (loading) {
		return (
			<div className="timeslot-selector">
				<div className="timeslot-loading">
					<Spin size="large" />
					<p>載入中 Loading ...</p>
				</div>
			</div>
		);
	}

	if (timeslots.length === 0) {
		if (moment().isBefore('2026-08-03T00:00:00+08:00')) {
			return (
				<div className="timeslot-selector">
					<div className="timeslot-header">
						<InfoCircleOutlined className="timeslot-icon" />
						<h2 className="timeslot-title">暫無時段可選 No Timeslots Available</h2>
						<p className="timeslot-subtitle">
							Tap & Grab 會於 2026年8月3日 開始接受訂單，謝謝！
							<br />
							We will be back on 3 Aug 2026. Thank you!
						</p>
					</div>
				</div>
			);
		}
		return (
			<div className="timeslot-selector">
				<div className="timeslot-header">
					<InfoCircleOutlined className="timeslot-icon" />
					<h2 className="timeslot-title">暫無時段可選 No Timeslots Available</h2>
					<p className="timeslot-subtitle">
						今日所有時段已過，歡迎明天 00:00 再來，謝謝！
						<br />
						All today's ordering time slots are now closed. You're welcome to order again from 00:00 tomorrow. Thank you!
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="timeslot-selector">
			<div className="timeslot-header">
				<ClockCircleOutlined className="timeslot-icon" />
				<h2 className="timeslot-title">
					選擇取餐時段
					<br />
					Select Pickup Timeslot
				</h2>
				<p className="timeslot-subtitle">
					<br />
					您只可在選定的取餐時段內領取餐點。若逾時未取餐，基於食物安全及衛生考慮，該餐點將被棄置，我們不會提供任何補償或退款。
					<br />
					<br />
					You may only collect your order during the selected pickup timeslot. If not collected on time, the meal will be discarded for food safety and hygiene reasons. No compensation or refund will be provided in such cases.
				</p>
			</div>

			<div className="timeslot-section">
				<h3 className="timeslot-section-title">可選擇的時段 Available Timeslots</h3>
				<div className="timeslot-list">
					{timeslots.map((timeslot) => {
						const isClosed = timeslot.isClosed || (timeslot.last_order_time ? dayjs().isAfter(dayjs(timeslot.last_order_time)) : false);
						const isUnavailable = timeslot.isFull || isClosed;
						return (
							<div
								key={timeslot._id}
								className={`timeslot-item ${selectedTimeslot === timeslot._id ? 'selected' : ''} ${isUnavailable ? 'disabled' : ''}`}
								onClick={() => handleTimeSlotClick(timeslot)}
							>
								<span className={`timeslot-time ${selectedTimeslot === timeslot._id ? 'selected' : ''}`}>
									{`${dayjs(timeslot.timeslot_start_time).format('HH:mm')}-${dayjs(timeslot.timeslot_end_time).format('HH:mm')} `}
									<span className="timeslot-last-order">
										{`(截單 last order ${dayjs(timeslot.last_order_time).format('HH:mm')})`}
									</span>
								</span>
								{timeslot.isFull && (
									<span className="timeslot-badge">已滿 Full</span>
								)}
								{selectedTimeslot === timeslot._id && (
									<CheckCircleOutlined className="timeslot-check-icon" />
								)}
							</div>
						);
					})}
				</div>
			</div>

			<div className="timeslot-footer">
				<button
					className="timeslot-continue-btn"
					onClick={handleContinue}
					disabled={!selectedTimeslot}
				>
					下一步 Continue
				</button>
			</div>
		</div>
	);
};

export default TimeslotSelector;
